import { render, staticRenderFns } from "./PageCompare.vue?vue&type=template&id=6aa662e7&scoped=true&"
import script from "./PageCompare.vue?vue&type=script&lang=js&"
export * from "./PageCompare.vue?vue&type=script&lang=js&"
import style0 from "./PageCompare.vue?vue&type=style&index=0&id=6aa662e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa662e7",
  null
  
)

export default component.exports